var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.imageSrc)?_c('div',{staticClass:"smvp-slides-widget"},[_c('img',{attrs:{"src":_vm.imageSrc,"alt":"Slide Image"},on:{"load":_vm.onImageLoad,"error":_vm.onImageError}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }